const deadline = 'December 12, 2025';
const BUYBACK_CONFIG = {
  unitPriceUsd: 26,
  poolCapUsd: 5000000,
  minParticipationUsd: 10000,
  companyName: 'Alumni Ventures',
  buybackTitle: 'AV Unitholder Buyback Portal',
  summaryHeading: 'Buyback Details',
  campaignKey: 'buyback2025',
  enableFeature: true,
  availabilityWindow: {
    start: '2025-12-02T00:00:00.000',
    end: '2026-01-31T23:59:59.999',
  },
  submissionWindow: {
    start: '2025-12-02T00:00:00.000',
    end: '2025-12-12T23:59:59.999',
  },
  summary: {
    totalAmount: '$10,000,000',
    minimum: '$10,000',
    pricePerShare: '$26',
    deadline,
    settlementDate: 'January 15, 2026',
    maximumParticipation: '2x Pro-Rata',
  },
  ceoNote: {
    heading: 'A Note from the CEO',
    body: 'Periodically, AV buys back units from its owners. We\'re now inviting you, as one of AV\'s owners, to participate in a small, fixed-price, $5M unit buyback. We\'re making this offer to demonstrate how seriously we take owner liquidity. With this buyback, AV will have returned over $100M to owners. Whether you sell some units or hold tight is up to you.',
    closing: '',
    signature: '- Mike',
  },
  importantNotes: [
    'We will buy eligible units at $26 per unit.',
    'Depending on participation, you may not get 2x your pro rata.',
    'If you are invested through one than one legal entity, submit separate elections for each. ',
    'We will sell your oldest units first for each entity.',
    'Any submissions not received by December 12, 2025 will be consider a "pass."',

  ],
  contactEmail: 'buyback@av.vc',
  acknowledgementCopy: [
    'Review all your elections carefully.',
    'Ensure your contact information is accurate.',
    'Remember that all elections are binding.',
    'Keep a copy of this form for your records.',
  ],
  nextSteps: [
    'We will calculate the amount and notify you.',
    'DocuSign documents will be sent for your electronic signature.',
    'Settlement will occur on January 15, 2026.',
  ],
  legalDisclosure: 'This buyback offer is made solely on the terms and conditions set forth herein and in the related documentation. The information contained herein does not constitute an offer to sell or a solicitation of an offer to buy securities in any jurisdiction where such offer or solicitation would be unlawful. This offer is being made only to existing unitholders of Alumni Ventures and is not transferable. All elections are binding and irrevocable once submitted. Unitholders should consult with their own tax and legal advisors regarding the implications of participating in this buyback. Alumni Ventures reserves the right to modify or terminate this offer at any time prior to the deadline. Past performance is not indicative of future results. All investments involve risk, including the potential loss of principal. By participating in this buyback, you acknowledge that you have read, understood, and agree to be bound by all terms and conditions of this offer.',
};

const parseConfigDate = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed;
};

const normalizeWindowBounds = (windowConfig) => {
  if (!windowConfig || typeof windowConfig !== 'object') {
    return { start: null, end: null };
  }

  const startValue = windowConfig.start ?? windowConfig.startDate ?? windowConfig.open;
  const endValue = windowConfig.end ?? windowConfig.endDate ?? windowConfig.close;

  return {
    start: parseConfigDate(startValue),
    end: parseConfigDate(endValue),
  };
};

export const getBuybackSubmissionWindow = () => normalizeWindowBounds(BUYBACK_CONFIG.submissionWindow);

export const isWindowActive = (windowConfig, referenceDate = new Date()) => {
  const { start, end } = normalizeWindowBounds(windowConfig);

  if (!start && !end) {
    return false;
  }

  const current = referenceDate instanceof Date ? referenceDate : parseConfigDate(referenceDate);
  if (!current) {
    return false;
  }

  if (start && current < start) {
    return false;
  }

  if (end && current > end) {
    return false;
  }

  return true;
};

export const isBuybackPageWindowActive = (referenceDate) => isWindowActive(BUYBACK_CONFIG.availabilityWindow, referenceDate);

export const isBuybackSubmissionWindowActive = (referenceDate) => isWindowActive(BUYBACK_CONFIG.submissionWindow, referenceDate);

export default BUYBACK_CONFIG;
